export default __webpack_public_path__ + "static/media/378.7d5f8c79.png";